import React from "react";
import ButtonsFeatures from "./ButtonsFeatures";
import { useTranslation } from "react-i18next";

const MapBoxFeatures = ({
  customNavigationButtonClass,
  initialButtonNavigationsVisibility,
  toggleNavigationPanel,
  toggleCustomNavigationPanel,
  sendDataToServ,
  originMarker,
  destinationMarker,
  showInputKML,
  setShowInputKML,
  handleKmlUpload,
  showInputGPX,
  setShowInputGPX,
  handleProjectUpload,
  handleExport,
  userPack,
  handleGpxUpload,
  setShowInputGPXKml,
  showInputGPXKml,
  setVisibleComponent,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="d-flex mb-4">
        <button
          className={` ${initialButtonNavigationsVisibility}`}
          onClick={toggleNavigationPanel}
        >
          {t("initialDirections")}
        </button>
        <button
          className={`${customNavigationButtonClass}`}
          onClick={toggleCustomNavigationPanel}
        >
          {t("customDirections")}
        </button>
      </div>
      <div className="">
        <ButtonsFeatures
          sendDataToServ={sendDataToServ}
          originMarker={originMarker}
          destinationMarker={destinationMarker}
          userPack={userPack}
          handleExport={handleExport}
          setShowInputGPX={setShowInputGPX}
          setShowInputKML={setShowInputKML}
          showInputGPX={showInputGPX}
          showInputKML={showInputKML}
          handleKmlUpload={handleKmlUpload}
          handleProjectUpload={handleProjectUpload}
          handleGpxUpload={handleGpxUpload}
          setShowInputGPXKml={setShowInputGPXKml}
          showInputGPXKml={showInputGPXKml}
          setVisibleComponent={setVisibleComponent}
        />
      </div>
    </>
  );
};

export default MapBoxFeatures;
